import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Primary auth = httpOnly cookie. Some mobile browsers (iOS Safari, private modes)
// block cross-site cookies, so we keep a bearer-token fallback for those devices only.
const FALLBACK_KEY = "co_session_fallback";
const ORG_KEY = "co_active_org";

export const getActiveOrg = () => {
  try {
    return localStorage.getItem(ORG_KEY);
  } catch {
    return null;
  }
};

export const setActiveOrg = (orgId) => {
  try {
    if (orgId) localStorage.setItem(ORG_KEY, orgId);
    else localStorage.removeItem(ORG_KEY);
  } catch {
    /* storage unavailable */
  }
};

export const getFallbackToken = () => {
  try {
    return localStorage.getItem(FALLBACK_KEY);
  } catch {
    return null;
  }
};

export const setFallbackToken = (token) => {
  try {
    if (token) localStorage.setItem(FALLBACK_KEY, token);
    else localStorage.removeItem(FALLBACK_KEY);
  } catch {
    /* storage unavailable — cookie-only mode */
  }
};

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getFallbackToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const org = getActiveOrg();
  if (org) config.headers["X-Org-Id"] = org;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const token = getFallbackToken();
  return token ? `${API}/files/${path}?auth=${encodeURIComponent(token)}` : `${API}/files/${path}`;
}

export function reportUrl(propertyId, month) {
  const token = getFallbackToken();
  const params = new URLSearchParams();
  if (month) params.set("month", month);
  if (token) params.set("auth", token);
  const qs = params.toString();
  return `${API}/reports/property/${propertyId}/monthly.pdf${qs ? `?${qs}` : ""}`;
}

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data.path;
}
